import { GzRelayUpdateWebComponent } from './component/GzRelayUpdateWebComponent';

export { GzRelayUpdateWebComponent };
